import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Loader2, Mail } from "lucide-react";

export function SerialNumberEmailDialog({
  open,
  onOpenChange,
  itemForEmail,
  emailNote,
  setEmailNote,
  sendingEmail,
  onSend,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Erinnerungs-E-Mail senden</DialogTitle>
          <DialogDescription>
            Senden Sie eine E-Mail-Erinnerung für {itemForEmail?.product_name} ({itemForEmail?.customer_name})
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label>Notiz (optional)</Label>
            <Textarea
              value={emailNote}
              onChange={(e) => setEmailNote(e.target.value)}
              placeholder="Zusätzliche Informationen für die E-Mail..."
              rows={3}
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Abbrechen</Button>
          <Button onClick={onSend} disabled={sendingEmail} data-testid="send-email-btn">
            {sendingEmail ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : <Mail className="w-4 h-4 mr-2" />}
            E-Mail senden
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
